export const SL_ERROR_404 = {
	title: 'Oops, 404 Error!',
	info: 'Sorry! It seems something went wrong on our end!',
	imgUrl: 'https://assets.sololearn.com/404.png',
	linkText: 'Go to Homepage',
	linkTo: '/',
	hasBackButton: false,
	backTo: '/',
};
